module.exports = __webpack_public_path__ + "static/media/about.1bc4d71d.jpeg";